import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useGlobalRoutesData from '@usas/ui-web/state/security/UseGlobalRoutesData';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import useMemberPersistentStorage from '@usas/ui-web/state/memberPersistentStorage/UseMemberPersistentStorage';
import useSearchMemberData from '@usas/ui-web/state/searchMember/UseSearchMemberData';

const useMemberSearch = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();
  const { getGlobalRoute } = useGlobalRoutesData();
  const { setPersistentStorage, resetPersistentStorage } = useMemberPersistentStorage();
  const { searchMemberState } = useSearchMemberData();

  const onEditPerson = (e, personId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    console.log('Editing person with ID:', personId);

    setPersistentStorage(personId, 'member-id', navRoutes.MEMBER_SEARCH.route, 'Back to Member Search');
    const route = getGlobalRoute('MEMBER_INFO');
    if (route) {
      console.log('Navigating to route:', route.route);
      navigate(route?.route);
    }
  };

  useEffect(() => {
    resetPersistentStorage();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchMemberState, onEditPerson };
};

export default useMemberSearch;